// extracted by mini-css-extract-plugin
export var boldText = "_5y-4";
export var checkboxContainer = "_5y-6";
export var closeIcon = "_5y-i";
export var container = "_5y-0";
export var drawer = "_5y-8";
export var drawerContent = "_5y-9";
export var extraSmallText = "_5y-5";
export var fulfillmentGroupTable = "_5y-e";
export var largeText = "_5y-3";
export var loadingSpinnerContainer = "_5y-j";
export var mediumText = "_5y-2";
export var narrow = "_5y-f";
export var notificationLink = "_5y-l";
export var packageCheckIconContainer = "_5y-7";
export var slideoutHeaderActions = "_5y-g";
export var slideoutHeaderActionsShifted = "_5y-h";
export var slideoutHeaderContainer = "_5y-a";
export var slideoutModal = "_5y-c";
export var stickyHeaderWrapper = "_5y-b";
export var table = "_5y-k";
export var tableContainer = "_5y-d";
export var tertiaryText = "_5y-1";